import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {AxiosResponse} from "axios";

type RequestBody = {
	compId: string;
	webCustNo: string;
	couponNo: string;
};

type ResponseBody = {
	errorCode: string;
	errorMsg: string;
	couponIssueSeq: string;
};

const getPath = () => `${publicRuntimeConfig.ENV_CHORUS_API_BASEPATH}/cpon/issueCoupon`;

const couponDownAsync = async (data: RequestBody): Promise<AxiosResponse<ResponseBody, any>> => {
	const reuslt = await useConfigureAxios(getPath(), {
		method: "POST",
		data,
	});
	return reuslt;
};

export default couponDownAsync;
export type {RequestBody};
